<template>
    <main class="home">
        <section v-if="member && member.fiscal" class="hero hero--noheight">
            <div class="hero__bg">
                <div
                    class="hero__bg__img"
                    :style="{ backgroundImage: 'url(' + member.bg_image + ')' }"
                ></div>
            </div>
            <!-- <div class="hero__layer hero__layer--blur"></div> -->

            <div class="hero__top hero__top--single">
                <div class="container">
                    <div class="hero__top__inner">
                        <div class="hero__top__block desktop">
                            <router-link
                                :to="{ path: '/' }"
                                class="hero__top__back"
                            >
                                ⟵ ΠΙΣΩ ΣΤΑ ΠΟΘΕΝ ΕΣΧΕΣ
                            </router-link>
                        </div>
                        <div class="hero__top__block">
                            <ul class="hero__top__menu">
                                <li>
                                    <a
                                        :href="`https://vouliwatch.gr/mp/${member.slug}?qm=${member.vw_id}`"
                                        target="_blank"
                                        class="btn btn--light"
                                        >ΚΑΝΕ ΕΡΩΤΗΣΗ</a
                                    >
                                </li>
                                <li>
                                    <a
                                        :href="`https://vouliwatch.gr/mp/${member.slug}`"
                                        target="_blank"
                                        class="btn btn--noback"
                                        >ΠΛΗΡΕΣ ΠΡΟΦΙΛ</a
                                    >
                                </li>
                                <li>
                                    <div
                                        class="drop-down-filter drop-down-filter--radius"
                                    >
                                        <div class="toggle">
                                            <span>ΛΗΨΗ ΔΗΛΩΣΗΣ</span>
                                        </div>
                                        <ul>
                                            <li>
                                                <a
                                                    :href="
                                                        member.fiscal[0].file
                                                    "
                                                    target="_blank"
                                                    >ΑΡΧΕΙΟ PDF
                                                    <i
                                                        class="fa fa-file-pdf-o"
                                                    ></i
                                                ></a>
                                            </li>
                                            <!-- <li><a href="/parliament/gr/ii-17-07-2019?group=">ΑΡΧΕΙΟ PNG <i class="fa fa-file-image-o"></i></a></li> -->
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <router-link
                                        :to="{
                                            path: '/compare',
                                            query: { member1: member.slug },
                                        }"
                                        class="btn btn--light"
                                    >
                                        ΣΥΓΚΡΙΣΗ
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="hero__main hero__main--single">
                <div class="container">
                    <div class="hero__top__block mobile">
                        <router-link
                            :to="{ path: '/' }"
                            class="hero__top__back"
                        >
                            ⟵ ΠΙΣΩ ΣΤΑ ΠΟΘΕΝ ΕΣΧΕΣ
                        </router-link>
                    </div>
                    <div class="hero__main__inner">
                        <div
                            class="hero__main__block hero__main__block--member"
                        >
                            <div class="circle-items">
                                <div
                                    class="circle-items__icon photo-icon photo-icon--180"
                                    :style="{
                                        backgroundImage:
                                            'url(' +
                                            getProfileImage(
                                                member.profile_image
                                            ) +
                                            ')',
                                    }"
                                >
                                    <div
                                        v-if="
                                            member.fiscal &&
                                            !member.fiscal[0].eu &&
                                            member.fiscal[0].parliament_group
                                        "
                                        class="photo-icon__logo"
                                        :style="{
                                            backgroundImage:
                                                'url(' +
                                                member.fiscal[0]
                                                    .parliament_group.logo_url +
                                                ')',
                                        }"
                                    ></div>
                                    <div
                                        v-if="
                                            member.fiscal &&
                                            member.fiscal[0].eu &&
                                            member.fiscal[0].parliament_group
                                        "
                                        class="photo-icon__logo"
                                        :style="{
                                            backgroundImage:
                                                'url(' +
                                                member.fiscal[0].politicalparty
                                                    .logo_url +
                                                ')',
                                        }"
                                    ></div>
                                </div>

                                <div class="circle-items__wrapper">
                                    <div class="circle-items__row">
                                        <div class="circle-items__item">
                                            <div
                                                class="circle-items__item__inner"
                                            >
                                                <div
                                                    class="circle-items__item__icon"
                                                >
                                                    <svg
                                                        id="Group_3612"
                                                        data-name="Group 3612"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="61.122"
                                                        height="55.132"
                                                        viewBox="0 0 61.122 55.132"
                                                    >
                                                        <path
                                                            id="Path_6345"
                                                            data-name="Path 6345"
                                                            d="M1101.131,249.244a1.385,1.385,0,0,0,1.385,1.384h2.733a13.856,13.856,0,0,0,22.827,6.024,1.385,1.385,0,0,0-1.913-2,11.077,11.077,0,0,1-17.979-4.02h8.777a1.385,1.385,0,1,0,0-2.77H1107.5a11.353,11.353,0,0,1-.073-1.236,11.076,11.076,0,0,1,.12-1.537h14.509a1.385,1.385,0,1,0,0-2.77H1108.3a11.087,11.087,0,0,1,18.059-3.534,1.385,1.385,0,1,0,1.958-1.959,13.852,13.852,0,0,0-22.965,5.493h-2.831a1.385,1.385,0,1,0,0,2.77h2.229a13.667,13.667,0,0,0-.092,1.537c0,.417.027.828.063,1.236h-2.2A1.386,1.386,0,0,0,1101.131,249.244Z"
                                                            transform="translate(-1075.559 -232.763)"
                                                            fill="#fff"
                                                        />
                                                        <path
                                                            id="Path_6346"
                                                            data-name="Path 6346"
                                                            d="M1138.584,269.571a2.911,2.911,0,0,0-1.7-.529c-1.651,0-3.5,1.212-5.3,2.387a19.852,19.852,0,0,1-3.385,1.925,17.667,17.667,0,0,1-6.467,1.21,28.488,28.488,0,0,1-10.135-2.259l-.272-.1.279-.086a9.961,9.961,0,0,1,2.848-.331c1.4,0,3.01.153,4.57.3s3.192.307,4.642.307c2.3,0,3.735-.4,4.518-1.262a3.192,3.192,0,0,0,.667-2.582c-.32-3.3-4.761-3.6-9.468-3.912a35,35,0,0,1-5.936-.723,22.1,22.1,0,0,1-3.827-1.548,19.7,19.7,0,0,0-7.7-2.385c-.416-.021-.843-.032-1.269-.032a39.474,39.474,0,0,0-11.038,1.9v-1.986a1.329,1.329,0,0,0-1.326-1.328h-8.823a1.329,1.329,0,0,0-1.327,1.328V278a1.329,1.329,0,0,0,1.327,1.328h8.823A1.328,1.328,0,0,0,1089.61,278v-2.258a63.154,63.154,0,0,1,11.1,4.566c.5.242,1,.488,1.515.737.72.349,1.468.738,2.191,1.114,2.45,1.274,4.983,2.593,7.219,2.812a9.26,9.26,0,0,0,.927.043,29.331,29.331,0,0,0,5.225-.69c.735-.141,1.495-.286,2.219-.4.977-.155,1.966-.282,2.926-.4a35.4,35.4,0,0,0,5.2-.9c4.738-1.408,10.167-8.267,10.505-8.834C1139.323,272.609,1139.61,270.279,1138.584,269.571ZM1088.5,278a.216.216,0,0,1-.214.216h-8.823a.216.216,0,0,1-.215-.216V259.863a.216.216,0,0,1,.215-.216h8.823a.216.216,0,0,1,.214.216Zm49.045-4.871c-.314.51-5.578,7.02-9.774,8.266a34.7,34.7,0,0,1-5,.863c-.921.117-1.965.251-2.961.409-.74.118-1.511.265-2.259.408a28.445,28.445,0,0,1-4.987.667c-.281,0-.55-.012-.8-.037-1.993-.2-4.415-1.457-6.757-2.675-.735-.381-1.494-.776-2.224-1.13-.515-.249-1.017-.493-1.525-.742a62.572,62.572,0,0,0-11.609-4.729c-.013,0-.025,0-.039,0V263.161c.018,0,.037,0,.055,0a39.159,39.159,0,0,1,10.984-1.937c.4,0,.809.01,1.2.03a18.723,18.723,0,0,1,7.217,2.263,22.805,22.805,0,0,0,4.057,1.631,35.815,35.815,0,0,0,6.172.762c4.148.278,8.068.542,8.284,2.765a2.037,2.037,0,0,1-.344,1.606c-.509.559-1.713.844-3.576.844-1.39,0-2.982-.152-4.529-.3-1.583-.151-3.221-.307-4.684-.307a11.146,11.146,0,0,0-3.218.386l-2.039.621a.636.636,0,0,0-.045,1.2l1.987.771a29.673,29.673,0,0,0,10.6,2.346,18.929,18.929,0,0,0,6.924-1.3,20.712,20.712,0,0,0,3.632-2.053c1.632-1.069,3.321-2.174,4.594-2.174a1.655,1.655,0,0,1,.967.291A3.2,3.2,0,0,1,1137.543,273.126Z"
                                                            transform="translate(-1078.133 -229.879)"
                                                            fill="#fff"
                                                        />
                                                    </svg>
                                                </div>
                                                <div
                                                    class="circle-items__item__text"
                                                >
                                                    <p>
                                                        <strong
                                                            >€
                                                            {{
                                                                kFormatter(
                                                                    member
                                                                        .fiscal[0]
                                                                        .total_revenue
                                                                )
                                                            }}</strong
                                                        >
                                                    </p>
                                                    <p class="desktop">
                                                        ΕΙΣΟΔΗΜΑΤΑ
                                                    </p>
                                                </div>
                                                <div
                                                    class="circle-items__item__text circle-items__item__text--mobile mobile"
                                                >
                                                    <p>ΕΙΣΟΔΗΜΑΤΑ</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="circle-items__item">
                                            <div
                                                class="circle-items__item__inner"
                                            >
                                                <div
                                                    class="circle-items__item__icon"
                                                >
                                                    <svg
                                                        id="Group_3575"
                                                        data-name="Group 3575"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="63.148"
                                                        height="53.619"
                                                        viewBox="0 0 63.148 53.619"
                                                    >
                                                        <path
                                                            id="Path_6315"
                                                            data-name="Path 6315"
                                                            d="M1029.9,981.807c-1.685,0-3.573,1.237-5.408,2.437a20.276,20.276,0,0,1-3.455,1.965,18.037,18.037,0,0,1-6.6,1.235,29.08,29.08,0,0,1-10.346-2.306l-.278-.107.285-.087a10.179,10.179,0,0,1,2.907-.337c1.432,0,3.072.156,4.665.306s3.259.313,4.74.313c2.347,0,3.811-.41,4.61-1.288a3.255,3.255,0,0,0,.681-2.635c-.327-3.367-4.86-3.671-9.664-3.993a35.714,35.714,0,0,1-6.06-.738,22.558,22.558,0,0,1-3.906-1.58,20.142,20.142,0,0,0-7.859-2.435c-.425-.021-.861-.033-1.3-.033a40.3,40.3,0,0,0-11.267,1.941v-2.027a1.355,1.355,0,0,0-1.354-1.354h-9.007a1.356,1.356,0,0,0-1.355,1.354v18.511a1.356,1.356,0,0,0,1.355,1.355h9.007a1.355,1.355,0,0,0,1.354-1.355v-2.305a64.446,64.446,0,0,1,11.333,4.66l1.546.753c.736.357,1.5.754,2.237,1.137,2.5,1.3,5.086,2.647,7.37,2.87a9.325,9.325,0,0,0,.946.045,29.937,29.937,0,0,0,5.335-.705c.749-.144,1.524-.292,2.264-.41,1-.158,2.007-.288,2.986-.413a36.008,36.008,0,0,0,5.3-.923c4.835-1.437,10.378-8.439,10.723-9.018.7-1.191,1-3.57-.052-4.293A2.972,2.972,0,0,0,1029.9,981.807Zm-49.387,9.142a.22.22,0,0,1-.219.22h-9.007a.22.22,0,0,1-.22-.22V972.437a.22.22,0,0,1,.22-.219h9.007a.219.219,0,0,1,.219.219Zm50.064-4.973c-.32.521-5.693,7.166-9.977,8.438a35.415,35.415,0,0,1-5.1.881c-.94.12-2.006.257-3.022.418-.754.12-1.543.27-2.305.417a29.053,29.053,0,0,1-5.09.681c-.288,0-.563-.012-.818-.037-2.034-.2-4.506-1.487-6.9-2.731-.75-.389-1.524-.792-2.27-1.153-.524-.254-1.038-.5-1.557-.757a63.845,63.845,0,0,0-11.85-4.828c-.014,0-.026,0-.04,0V975.8c.019,0,.037,0,.056,0a39.976,39.976,0,0,1,11.212-1.977c.413,0,.826.01,1.228.031a19.1,19.1,0,0,1,7.369,2.311,23.318,23.318,0,0,0,4.141,1.664,36.536,36.536,0,0,0,6.3.777c4.235.284,8.236.553,8.458,2.823a2.078,2.078,0,0,1-.352,1.639c-.52.572-1.748.862-3.65.862-1.419,0-3.044-.156-4.623-.307-1.616-.154-3.288-.313-4.782-.313a11.412,11.412,0,0,0-3.285.394l-2.082.633a.649.649,0,0,0-.046,1.226l2.029.787a30.29,30.29,0,0,0,10.816,2.395,19.317,19.317,0,0,0,7.068-1.322,21.176,21.176,0,0,0,3.708-2.1c1.666-1.091,3.39-2.219,4.689-2.219a1.684,1.684,0,0,1,.987.3A3.268,3.268,0,0,1,1030.573,985.976Z"
                                                            transform="translate(-969.928 -944.49)"
                                                            fill="#fff"
                                                        />
                                                        <path
                                                            id="Path_6316"
                                                            data-name="Path 6316"
                                                            d="M1020.11,947.654a.912.912,0,0,0-.007,1.824l6.515.049L1011.641,964.5l-6.37-6.369a1.134,1.134,0,0,0-1.6,0L992.3,969.5a1.135,1.135,0,1,0,1.6,1.606l10.559-10.559,6.37,6.368a1.133,1.133,0,0,0,1.6,0l15.781-15.782.05,6.508a.912.912,0,0,0,1.824-.007v-9.978Z"
                                                            transform="translate(-966.951 -947.654)"
                                                            fill="#fff"
                                                        />
                                                    </svg>
                                                </div>
                                                <div
                                                    class="circle-items__item__text"
                                                >
                                                    <p>
                                                        <strong
                                                            >€
                                                            {{
                                                                kFormatter(
                                                                    member
                                                                        .fiscal[0]
                                                                        .total_stocks
                                                                )
                                                            }}</strong
                                                        >
                                                    </p>
                                                    <p class="desktop">
                                                        ΕΠΕΝΔΥΤΙΚΑ ΠΡΟΪΟΝΤΑ
                                                    </p>
                                                </div>
                                                <div
                                                    class="circle-items__item__text circle-items__item__text--mobile mobile"
                                                >
                                                    <p>ΕΠΕΝΔΥΤΙΚΑ ΠΡΟΪΟΝΤΑ</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="circle-items__row">
                                        <div class="circle-items__item">
                                            <div
                                                class="circle-items__item__inner"
                                            >
                                                <div
                                                    class="circle-items__item__icon"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="69.209"
                                                        height="29.595"
                                                        viewBox="0 0 69.209 29.595"
                                                    >
                                                        <path
                                                            id="Path_6278"
                                                            data-name="Path 6278"
                                                            d="M1135.432,256.677c-2.149-2.418-5.273-3.087-8.293-3.733a21.578,21.578,0,0,1-5.525-1.7,19.768,19.768,0,0,1-4.068-3.177,21.743,21.743,0,0,0-4.493-3.48c-2.53-1.325-5.382-1.632-8.33-1.851-3.2-.225-6.732-.384-10.5-.476l-.566-.1-.016.092c-4.651-.067-9.149-.075-14.688.122-.427.016-.844.036-1.256.056l-1.027.045.075,1.927,1.045-.046c.405-.019.816-.039,1.233-.055,2.581-.093,4.93-.137,7.177-.154a31.292,31.292,0,0,0-4.724,5.673.482.482,0,0,0,.345.74c1.426.178,2.919.377,4.465.583,1.98.262,4.051.536,6.188.8a151.053,151.053,0,0,0,18.2,1.286,82.1,82.1,0,0,0,9.594-.538c.147.087.286.185.439.266a23.047,23.047,0,0,0,6.021,1.878c2.842.608,5.526,1.183,7.253,3.124,1.816,2.061,2.044,5.05,2,8.252q-1.3.042-2.6.088c-1.173.041-2.346.08-3.485.116h-.086a6.534,6.534,0,0,0,.135-1.316,6.67,6.67,0,1,0-13.248,1.069c-11.366-.25-21.451-.6-30.743-1.069h0a6.666,6.666,0,0,0-13.286-.8c-.666-.046-1.333-.092-1.995-.143a18.8,18.8,0,0,1,8.92-17.019l-.982-1.662a20.745,20.745,0,0,0-9.782,19.689.963.963,0,0,0,.88.852c1,.081,2.008.15,3.017.22a6.623,6.623,0,0,0,6.551,5.523,6.7,6.7,0,0,0,6.377-4.743c9.553.483,19.933.842,31.7,1.1a6.632,6.632,0,0,0,11.727.224h.111c.221,0,.443.008.693.008h.044q1.755-.055,3.519-.117t3.515-.116a.965.965,0,0,0,.934-.941C1137.995,263.383,1137.884,259.457,1135.432,256.677Zm-52.717-6.977a30.306,30.306,0,0,1,4.931-5.561c1.919,0,3.783.012,5.658.038q-.576,3.368-1.166,6.748c-1.971-.244-3.889-.5-5.724-.739Q1084.507,249.93,1082.715,249.7Zm10.381,1.342q.6-3.425,1.185-6.847c3.695.09,7.163.247,10.3.467a19.4,19.4,0,0,1,7.57,1.634,20.047,20.047,0,0,1,4.08,3.189,32.923,32.923,0,0,0,2.788,2.377C1109.977,252.778,1100.547,251.938,1093.1,251.041Zm-9.137,14.776a.335.335,0,0,0-.007.042,4.728,4.728,0,0,1-9.391-.572,1.607,1.607,0,0,0-.013-.195,4.74,4.74,0,1,1,9.48,0A3.711,3.711,0,0,1,1083.959,265.818Zm43.662,1.155,0,0a4.732,4.732,0,0,1-8.759-.189,4.424,4.424,0,0,1-.321-1.695,4.74,4.74,0,1,1,9.48,0A4.661,4.661,0,0,1,1127.621,266.972Z"
                                                            transform="translate(-1068.712 -242.159)"
                                                            fill="#fff"
                                                        />
                                                    </svg>
                                                </div>
                                                <div
                                                    class="circle-items__item__text"
                                                >
                                                    <p>
                                                        <strong>{{
                                                            member.fiscal[0]
                                                                .total_mobiles
                                                                | formatMobiles
                                                        }}</strong>
                                                    </p>
                                                    <p class="desktop">
                                                        ΟΧΗΜΑΤΑ
                                                    </p>
                                                </div>
                                                <div
                                                    class="circle-items__item__text circle-items__item__text--mobile mobile"
                                                >
                                                    <p>ΟΧΗΜΑΤΑ</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="circle-items__item">
                                            <div
                                                class="circle-items__item__inner"
                                            >
                                                <div
                                                    class="circle-items__item__icon"
                                                >
                                                    <svg
                                                        id="Group_3621"
                                                        data-name="Group 3621"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="44.425"
                                                        height="56.554"
                                                        viewBox="0 0 44.425 56.554"
                                                    >
                                                        <path
                                                            id="Path_6284"
                                                            data-name="Path 6284"
                                                            d="M1105.294,767.328a7.46,7.46,0,0,1,5.309,2.2,1.09,1.09,0,0,0,1.541-1.542,9.681,9.681,0,0,0-16.02,3.746h-1.854a1.089,1.089,0,1,0,0,2.179h1.385a9.218,9.218,0,0,0-.047.925c0,.241.013.478.031.717h-1.368a1.09,1.09,0,1,0,0,2.18h1.783a9.756,9.756,0,0,0,9.24,6.79,9.642,9.642,0,0,0,6.683-2.675,1.089,1.089,0,1,0-1.5-1.578,7.483,7.483,0,0,1-5.182,2.074,7.564,7.564,0,0,1-6.917-4.611h5.848a1.09,1.09,0,0,0,0-2.18h-6.4a7.082,7.082,0,0,1-.039-.717,7.315,7.315,0,0,1,.066-.925h9.881a1.089,1.089,0,1,0,0-2.179h-9.275A7.506,7.506,0,0,1,1105.294,767.328Z"
                                                            transform="translate(-1081.512 -737.456)"
                                                            fill="#fff"
                                                        />
                                                        <path
                                                            id="Path_6285"
                                                            data-name="Path 6285"
                                                            d="M1121.4,773.815c0-.009,0-.089-.005-.1-2.028-21.711-13.154-25.882-16.516-26.644a.446.446,0,0,1-.34-.436v-7.187a.451.451,0,0,1,.048-.2l4.009-8.018a1.252,1.252,0,0,0-1.428-1.774l-4.339,1.1a.449.449,0,0,1-.414-.1l-2.364-2.161a1.246,1.246,0,0,0-1.691,0L1096,730.454a.446.446,0,0,1-.414.1l-4.339-1.1a1.252,1.252,0,0,0-1.429,1.774l4.009,8.017a.453.453,0,0,1,.048.2v7.187a.446.446,0,0,1-.339.436c-3.363.761-14.489,4.933-16.516,26.644,0,.01-.006.092-.006.1l-.007.136a9.571,9.571,0,0,0,2.328,7.468c1.926,2.053,4.934,3.093,8.939,3.093H1108.6c4.342,0,7.674-1.156,9.905-3.433A10.716,10.716,0,0,0,1121.4,773.815Zm-26.725-27.177V743.8h4.53a.4.4,0,0,0,0-.8h-4.53v-3.145h9.061v7.092h-9.061Zm-4.142-15.765a.451.451,0,0,1,.4-.652.5.5,0,0,1,.116.015l4.339,1.1a1.239,1.239,0,0,0,1.155-.289l2.362-2.162a.446.446,0,0,1,.607,0l2.363,2.162a1.24,1.24,0,0,0,1.154.289l4.339-1.1a.45.45,0,0,1,.513.637l-4.009,8.017a1.138,1.138,0,0,0-.058.16h-9.21a1.186,1.186,0,0,0-.058-.159Zm27.4,49.648c-2.075,2.118-5.214,3.192-9.332,3.192H1088.27c-3.775,0-6.584-.956-8.354-2.84a8.8,8.8,0,0,1-2.111-6.868l.011-.214c1.977-21.172,12.665-25.2,15.893-25.936a1.236,1.236,0,0,0,.381-.157.394.394,0,0,0,.182.049h9.864a.391.391,0,0,0,.182-.049,1.239,1.239,0,0,0,.382.157c3.228.732,13.916,4.764,15.9,25.98A9.852,9.852,0,0,1,1117.928,780.521Z"
                                                            transform="translate(-1076.974 -727.962)"
                                                            fill="#fff"
                                                        />
                                                    </svg>
                                                </div>
                                                <div
                                                    class="circle-items__item__text"
                                                >
                                                    <p>
                                                        <strong
                                                            >€
                                                            {{
                                                                kFormatter(
                                                                    member
                                                                        .fiscal[0]
                                                                        .total_deposits
                                                                )
                                                            }}</strong
                                                        >
                                                    </p>
                                                    <p class="desktop">
                                                        ΚΑΤΑΘΕΣΕΙΣ
                                                    </p>
                                                </div>
                                                <div
                                                    class="circle-items__item__text circle-items__item__text--mobile mobile"
                                                >
                                                    <p>ΚΑΤΑΘΕΣΕΙΣ</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="circle-items__row">
                                        <div class="circle-items__item">
                                            <div
                                                class="circle-items__item__inner"
                                            >
                                                <div
                                                    class="circle-items__item__icon"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="55.471"
                                                        height="44.107"
                                                        viewBox="0 0 55.471 44.107"
                                                    >
                                                        <path
                                                            id="Path_6258"
                                                            data-name="Path 6258"
                                                            d="M84.818,244.149,76.26,237.6v-8.641a.959.959,0,1,0-1.919,0v7.172L58.162,223.748a.957.957,0,0,0-1.151-.012l-26.9,19.808a.959.959,0,0,0,1.137,1.546l7.651-5.635V266.7a.959.959,0,0,0,.959.959H75.3a.959.959,0,0,0,.959-.959V240.014l7.392,5.658a.959.959,0,1,0,1.166-1.523Zm-23,21.589H53.1V244.91h8.714Zm12.524,0H62.776V244.91a.96.96,0,0,0-.959-.959H53.1a.96.96,0,0,0-.959.959v20.828H40.822V238.686a.935.935,0,0,0-.173-.517l16.919-12.46,16.773,12.837Z"
                                                            transform="translate(-29.723 -223.549)"
                                                            fill="#fff"
                                                        />
                                                    </svg>
                                                </div>
                                                <div
                                                    class="circle-items__item__text"
                                                >
                                                    <p>
                                                        <strong>{{
                                                            member.fiscal[0]
                                                                .total_properties
                                                        }}</strong>
                                                    </p>
                                                    <p class="desktop">
                                                        ΑΚΙΝΗΤΑ
                                                    </p>
                                                </div>
                                                <div
                                                    class="circle-items__item__text circle-items__item__text--mobile mobile"
                                                >
                                                    <p>ΑΚΙΝΗΤΑ</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="circle-items__item">
                                            <div
                                                class="circle-items__item__inner"
                                            >
                                                <div
                                                    class="circle-items__item__icon"
                                                >
                                                    <svg
                                                        id="Group_3577"
                                                        data-name="Group 3577"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="48.345"
                                                        height="46.349"
                                                        viewBox="0 0 48.345 46.349"
                                                    >
                                                        <path
                                                            id="Path_6317"
                                                            data-name="Path 6317"
                                                            d="M1021.661,1551.622h-2.877v-2.008a.417.417,0,0,0-.833,0v2.008h-3.6v-2.008a.417.417,0,0,0-.834,0v2.008h-3.6v-2.008a.417.417,0,0,0-.833,0v2.008h-3.6v-2.008a.417.417,0,0,0-.833,0v2.008h-3.6v-2.008a.417.417,0,0,0-.834,0v2.008h-3.6v-2.008a.417.417,0,0,0-.834,0v2.008h-3.6v-2.008a.417.417,0,0,0-.833,0v2.008h-3.6v-2.008a.417.417,0,0,0-.834,0v2.008h-3.6v-2.008a.417.417,0,0,0-.834,0v2.008h-2.877a3.142,3.142,0,0,0-3.139,3.138v37.647a3.143,3.143,0,0,0,3.139,3.139h42.067a3.142,3.142,0,0,0,3.138-3.139V1554.76A3.142,3.142,0,0,0,1021.661,1551.622Zm1.471,40.785a1.473,1.473,0,0,1-1.471,1.472H979.594a1.474,1.474,0,0,1-1.472-1.472v-29.63h45.01Zm0-30.463h-45.01v-7.184a1.473,1.473,0,0,1,1.472-1.471h2.877v2.146a.417.417,0,0,0,.834,0v-2.146h3.6v2.146a.417.417,0,0,0,.834,0v-2.146h3.6v2.146a.417.417,0,1,0,.833,0v-2.146h3.6v2.146a.417.417,0,0,0,.834,0v-2.146h3.6v2.146a.417.417,0,0,0,.834,0v-2.146h3.6v2.146a.417.417,0,1,0,.833,0v-2.146h3.6v2.146a.417.417,0,1,0,.833,0v-2.146h3.6v2.146a.417.417,0,0,0,.834,0v-2.146h3.6v2.146a.417.417,0,1,0,.833,0v-2.146h2.877a1.473,1.473,0,0,1,1.471,1.471Z"
                                                            transform="translate(-976.455 -1549.197)"
                                                            fill="#fff"
                                                        />
                                                        <path
                                                            id="Path_6318"
                                                            data-name="Path 6318"
                                                            d="M991.134,1584.344a1.038,1.038,0,0,0,1.038,1.038h2.05a10.387,10.387,0,0,0,17.111,4.516,1.038,1.038,0,1,0-1.433-1.5,8.305,8.305,0,0,1-13.478-3.013H1003a1.038,1.038,0,1,0,0-2.076h-7.095a7.639,7.639,0,0,1,.034-2.08h10.877a1.038,1.038,0,0,0,0-2.077H996.5a8.314,8.314,0,0,1,13.539-2.649,1.038,1.038,0,0,0,1.468-1.468,10.384,10.384,0,0,0-17.215,4.117h-2.123a1.038,1.038,0,0,0,0,2.077h1.671a10.477,10.477,0,0,0-.068,1.153c0,.313.02.621.047.927h-1.65A1.037,1.037,0,0,0,991.134,1584.344Z"
                                                            transform="translate(-978.898 -1552.991)"
                                                            fill="#fff"
                                                        />
                                                    </svg>
                                                </div>
                                                <div
                                                    class="circle-items__item__text"
                                                >
                                                    <p>
                                                        <strong
                                                            >€
                                                            {{
                                                                kFormatter(
                                                                    member
                                                                        .fiscal[0]
                                                                        .total_loans
                                                                )
                                                            }}</strong
                                                        >
                                                    </p>
                                                    <p class="desktop">
                                                        ΟΦΕΙΛΕΣ
                                                    </p>
                                                </div>
                                                <div
                                                    class="circle-items__item__text circle-items__item__text--mobile mobile"
                                                >
                                                    <p>ΟΦΕΙΛΕΣ</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="circle-items__row">
                                        <div class="circle-items__item">
                                            <div
                                                class="circle-items__item__inner"
                                            >
                                                <div
                                                    class="circle-items__item__icon"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="51.712"
                                                        height="44.654"
                                                        viewBox="0 0 51.712 44.654"
                                                    >
                                                        <path
                                                            id="Path_6347"
                                                            data-name="Path 6347"
                                                            d="M1014.81,1454.816H999.89v-2.541a3.035,3.035,0,0,0-3.031-3.031h-9.1a3.035,3.035,0,0,0-3.031,3.031v2.541H969.813a3.362,3.362,0,0,0-3.358,3.358v32.367a3.361,3.361,0,0,0,3.358,3.357h45a3.361,3.361,0,0,0,3.357-3.357v-32.367A3.361,3.361,0,0,0,1014.81,1454.816Zm-28.294-2.541a1.249,1.249,0,0,1,1.247-1.248h9.1a1.249,1.249,0,0,1,1.247,1.248v2.541H986.515Zm29.868,38.266a1.576,1.576,0,0,1-1.574,1.573h-45a1.576,1.576,0,0,1-1.575-1.573v-18.6h19.726v7.356a.446.446,0,0,0,.446.446h7.8a.446.446,0,0,0,.446-.446v-7.356h19.726Zm-27.528-11.691v-6.91h6.91v6.91Zm27.528-7.8H968.238v-12.874a1.576,1.576,0,0,1,1.575-1.574h45a1.576,1.576,0,0,1,1.574,1.574Z"
                                                            transform="translate(-966.455 -1449.243)"
                                                            fill="#fff"
                                                        />
                                                    </svg>
                                                </div>
                                                <div
                                                    class="circle-items__item__text"
                                                >
                                                    <p>
                                                        <strong
                                                            >€
                                                            {{
                                                                kFormatter(
                                                                    member
                                                                        .fiscal[0]
                                                                        .total_companies
                                                                )
                                                            }}</strong
                                                        >
                                                    </p>
                                                    <p class="desktop">
                                                        ΕΠΙΧΕΙΡΗΣΕΙΣ
                                                    </p>
                                                </div>
                                                <div
                                                    class="circle-items__item__text circle-items__item__text--mobile mobile"
                                                >
                                                    <p>ΕΠΙΧΕΙΡΗΣΕΙΣ</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="circle-items__item">
                                            <div
                                                class="circle-items__item__inner"
                                            >
                                                <div
                                                    class="circle-items__item__icon"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="53.854"
                                                        height="53.854"
                                                        viewBox="0 0 53.854 53.854"
                                                    >
                                                        <g
                                                            id="Group_3680"
                                                            data-name="Group 3680"
                                                            transform="translate(-662 -581)"
                                                        >
                                                            <g
                                                                id="Ellipse_152"
                                                                data-name="Ellipse 152"
                                                                transform="translate(662 581)"
                                                                fill="none"
                                                                stroke="#fff"
                                                                stroke-width="2"
                                                            >
                                                                <circle
                                                                    cx="26.5"
                                                                    cy="26.5"
                                                                    r="26.5"
                                                                    stroke="none"
                                                                />
                                                                <circle
                                                                    cx="26.5"
                                                                    cy="26.5"
                                                                    r="25.5"
                                                                    fill="none"
                                                                />
                                                            </g>
                                                            <line
                                                                id="Line_365"
                                                                data-name="Line 365"
                                                                x1="53"
                                                                y2="53"
                                                                transform="translate(662.5 581.5)"
                                                                fill="none"
                                                                stroke="#fff"
                                                                stroke-width="1"
                                                            />
                                                        </g>
                                                    </svg>
                                                </div>
                                                <div
                                                    class="circle-items__item__text"
                                                >
                                                    <p>
                                                        <strong>{{
                                                            paralipseis
                                                        }}</strong>
                                                    </p>
                                                    <p class="desktop">
                                                        ΠΑΡΑΛΕΙΨΕΙΣ
                                                    </p>
                                                </div>
                                                <div
                                                    class="circle-items__item__text circle-items__item__text--mobile mobile"
                                                >
                                                    <p>ΠΑΡΑΛΕΙΨΕΙΣ</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="circle-items__row">
                                        <div class="circle-items__item">
                                            <div
                                                class="circle-items__item__inner"
                                            >
                                                <div
                                                    class="circle-items__item__icon"
                                                >
                                                    <div
                                                        class="drop-down-filter drop-down-filter--colored"
                                                    >
                                                        <div class="toggle">
                                                            <span>{{
                                                                activeYear
                                                            }}</span>
                                                            <i
                                                                class="fa fa-chevron-down"
                                                            ></i>
                                                        </div>
                                                        <ul>
                                                            <li
                                                                v-for="(
                                                                    year, key
                                                                ) in fiscal_years"
                                                                v-bind:key="
                                                                    key +
                                                                    year +
                                                                    'f_years'
                                                                "
                                                            >
                                                                <a
                                                                    href="#"
                                                                    :class="{
                                                                        active:
                                                                            year ==
                                                                            activeYear,
                                                                    }"
                                                                    @click.prevent="
                                                                        setActiveYear(
                                                                            year
                                                                        )
                                                                    "
                                                                    >{{
                                                                        year
                                                                    }}</a
                                                                >
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div
                                                    class="circle-items__item__text"
                                                >
                                                    <p>
                                                        <strong>{{
                                                            `${member.first_name} ${member.last_name}` +
                                                            (hasPartner
                                                                ? " & σύζυγος"
                                                                : "")
                                                        }}</strong>
                                                    </p>
                                                    <p>{{ role }}</p>
                                                    <!-- <p>{{member.fiscal[0].goverment_position ? member.fiscal[0].goverment_position.name : 'ΒΟΥΛΕΥΤΗΣ'}} {{ member.fiscal[0].district }}</p> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="hero__main__block">
                            <line-chart
                                :chart_data="chart_data"
                                :fiscal_years="fiscal_chart_years"
                            ></line-chart>
                            <div
                                class="hero__main__block__note"
                                v-if="hasTotalsPartner"
                            >
                                <p>
                                    *Αθροιστικά δηλώσεων βουλευτών και συζύγων
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="cards" v-if="member.fiscal">
            <div class="fixed-compare fixed-compare--single">
                <div class="container container--sm">
                    <div class="fixed-compare__wrapper">
                        <div class="fixed-compare__block" v-if="member">
                            <div
                                class="photo-icon photo-icon--50"
                                :style="{
                                    backgroundImage:
                                        'url(' +
                                        getProfileImage(member.profile_image) +
                                        ')',
                                }"
                            ></div>
                            <div class="fixed-compare__name">
                                <p>{{ member.last_name }}</p>
                                <p>{{ member.first_name }}</p>
                            </div>
                        </div>

                        <div class="fixed-compare__block">
                            <div class="hero__top__block">
                                <ul class="hero__top__menu">
                                    <li>
                                        <div
                                            class="drop-down-filter drop-down-filter--colored"
                                        >
                                            <div class="toggle">
                                                <span>{{ activeYear }}</span>
                                                <i
                                                    class="fa fa-chevron-down"
                                                ></i>
                                            </div>
                                            <ul>
                                                <li
                                                    v-for="(
                                                        year, key
                                                    ) in fiscal_years"
                                                    v-bind:key="
                                                        key + year + 'f_years'
                                                    "
                                                >
                                                    <a
                                                        href="#"
                                                        :class="{
                                                            active:
                                                                year ==
                                                                activeYear,
                                                        }"
                                                        @click.prevent="
                                                            setActiveYear(year)
                                                        "
                                                        >{{ year }}</a
                                                    >
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li>
                                        <div
                                            class="drop-down-filter drop-down-filter--radius"
                                        >
                                            <div class="toggle desktop">
                                                <span>ΛΗΨΗ ΔΗΛΩΣΗΣ</span>
                                            </div>
                                            <ul>
                                                <li>
                                                    <a
                                                        :href="
                                                            member.fiscal[0]
                                                                .file
                                                        "
                                                        target="_blank"
                                                        >ΑΡΧΕΙΟ PDF
                                                        <i
                                                            class="fa fa-file-pdf-o"
                                                        ></i
                                                    ></a>
                                                </li>
                                                <!-- <li><a href="/parliament/gr/ii-17-07-2019?group=">ΑΡΧΕΙΟ PNG <i class="fa fa-file-image-o"></i></a></li> -->
                                            </ul>
                                        </div>
                                    </li>

                                    <li>
                                        <router-link
                                            :to="{
                                                path: '/compare',
                                                query: { member1: member.slug },
                                            }"
                                            class="btn btn--light"
                                        >
                                            ΣΥΓΚΡΙΣΗ
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cards__filters">
                <div class="cards__filters__toggle" v-if="hasPartner">
                    <p
                        class="cards__filters__toggle__label"
                        :class="{ active: !partner }"
                    >
                        ΒΟΥΛΕΥΤΗΣ
                    </p>
                    <label class="switch">
                        <input type="checkbox" v-model="partner" />
                        <span class="slider round"></span>
                    </label>
                    <p
                        class="cards__filters__toggle__label"
                        :class="{ active: partner }"
                    >
                        ΣΥΖΥΓΟΣ
                    </p>
                </div>

                <div class="cards__filters__menu">
                    <scrollactive
                        class="my-nav"
                        active-class="active"
                        :modifyUrl="false"
                        :offset="150"
                    >
                        <ul>
                            <li>
                                <a href="#revenues" class="scrollactive-item"
                                    >ΕΙΣΟΔΗΜΑΤΑ</a
                                >
                            </li>
                            <li>
                                <a href="#stocks" class="scrollactive-item"
                                    >ΕΠΕΝΔΥΤΙΚΑ ΠΡΟΪΟΝΤΑ</a
                                >
                            </li>
                            <li>
                                <a href="#deposits" class="scrollactive-item"
                                    >ΚΑΤΑΘΕΣΕΙΣ</a
                                >
                            </li>
                            <li>
                                <a href="#loans" class="scrollactive-item"
                                    >ΔΑΝΕΙΑΚΕΣ ΥΠΟΧΡΕΩΣΕΙΣ & ΟΦΕΙΛΕΣ</a
                                >
                            </li>
                            <li>
                                <a href="#companies" class="scrollactive-item"
                                    >ΣΥΜΜΕΤΟΧΗ ΣΕ ΕΠΙΧΕΙΡΗΣΕΙΣ</a
                                >
                            </li>
                            <li>
                                <a href="#properties" class="scrollactive-item"
                                    >ΑΚΙΝΗΤΑ</a
                                >
                            </li>
                            <li>
                                <a href="#vehicles" class="scrollactive-item"
                                    >ΟΧΗΜΑΤΑ</a
                                >
                            </li>
                        </ul>
                    </scrollactive>
                </div>
            </div>

            <div class="cards__main">
                <div class="container container--sm">
                    <member-tables
                        :memberfiscal="member.fiscal[0]"
                        :partner="partner"
                    ></member-tables>
                    <div class="cards__bottom">
                        <router-link
                            :to="{ path: '/' }"
                            class="btn btn--noback btn--noback--dark"
                        >
                            ΑΝΑΖΗΤΗΣΗ ΔΗΛΩΣΕΩΝ
                        </router-link>
                        <router-link
                            :to="{
                                path: '/compare',
                                query: { member1: member.slug },
                            }"
                            class="btn btn--std"
                        >
                            ΣΥΓΚΡΙΣΗ
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import $ from "jquery";
import LineChart from "../components/LineChart";
import MemberTables from "../components/MemberTables";
export default {
    components: {
        LineChart,
        MemberTables,
    },
    data() {
        return {
            member: {
                fiscal: null,
            },
            loading: false,
            activeYear: null,
            fiscal_years: [],
            fiscal_chart_years: [],
            chart_data: [],
            fiscal_totals: [],
            partner: false,
            pageTitle: "πόθεν έσχες - vouliwatch",
        };
    },

    mounted() {
        if (this.$route.query.year) {
            this.activeYear = this.$route.query.year;
        }
        this.getMember();
    },
    updated() {
        this.$nextTick(function () {
            this.initUI();
        });
    },

    methods: {
        setActiveYear(year) {
            this.activeYear = year;
            this.getMember();
        },

        getMember() {
            this.loading = true;
            this.$emit("updateLoader", this.loading);
            const csrfToken = document.head.querySelector(
                'meta[name="csrf-token"]'
            ).content;
            axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
            axios
                .post("/api/member", {
                    data: {
                        year: this.activeYear,
                        slug: this.$route.params.name,
                    },
                })
                .then((response) => {
                    this.member = response.data.member;
                    this.fiscal_years = response.data.fiscal_totals.map(
                        (a) => a.year_of_use
                    );
                    this.fiscal_chart_years = response.data.fiscal_totals
                        .map(
                            (a) =>
                                `${a.with_partner ? "*" : ""}${a.year_of_use}`
                        )
                        .reverse();
                    this.activeYear = this.member.fiscal[0].year_of_use;
                    this.fiscal_totals = response.data.fiscal_totals;
                    this.formatChartData();
                    this.loading = false;
                    this.$emit("updateLoader", this.loading);
                    document.title = `${this.member.first_name} ${this.member.last_name} | πόθεν έσχες - vouliwatch`;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                    this.$emit("updateLoader", this.loading);
                });
        },

        getProfileImage(profile_image) {
            if (profile_image != " ") {
                return profile_image;
            }
            return "/images/default_profile_image.svg";
        },

        kFormatter(num) {
            if (Math.abs(num) < 1000) {
                return Math.sign(num) * Math.abs(num);
            } else if (Math.abs(num) >= 1000 && Math.abs(num) < 1000000) {
                return Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k";
            } else {
                return (
                    Math.sign(num) * (Math.abs(num) / 1000000).toFixed(2) + "M"
                );
            }
        },

        formatChartData() {
            if (!this.fiscal_totals.length) {
                return;
            }
            this.chart_data.pointStart =
                this.fiscal_totals.reverse()[0].year_of_use;
            this.chart_data.series = [];
            let series_obj_revenue = {};
            series_obj_revenue.name = "ΕΙΣΟΔΗΜΑΤΑ";
            series_obj_revenue.data = [];
            let series_obj_deposits = {};
            series_obj_deposits.name = "ΚΑΤΑΘΕΣΕΙΣ";
            series_obj_deposits.data = [];
            let series_obj_loans = {};
            series_obj_loans.name = "ΔΑΝΕΙΑ & ΟΦΕΙΛΕΣ";
            series_obj_loans.data = [];
            this.fiscal_totals.forEach((element, index) => {
                series_obj_revenue.data.push(parseFloat(element.total_revenue));
                series_obj_deposits.data.push(
                    parseFloat(element.total_deposits)
                );
                series_obj_loans.data.push(parseFloat(element.total_loans));
            });
            this.chart_data.series.push(series_obj_revenue);
            this.chart_data.series.push(series_obj_deposits);
            this.chart_data.series.push(series_obj_loans);
        },

        initUI() {
            $(".drop-down-filter .toggle").click(function (e) {
                e.stopPropagation();
                $(this).parent().toggleClass("open");
            });
            $(".drop-down-filter ul li input").click(function (e) {
                e.stopPropagation();
            });
            $(".drop-down-filter label, .drop-down-filter input").click(
                function (e) {
                    e.stopPropagation();
                }
            );
            $(document).click(function () {
                $(".drop-down-filter").removeClass("open");
            });

            $(window).scroll(function () {
                if (!$(".fixed-compare").length) return;
                var from_top = $(".cards__filters").offset().top;
                if ($(this).scrollTop() >= from_top - 70) {
                    $(".fixed-compare").addClass("active");
                    $(".cards__filters").addClass("active");
                } else {
                    $(".fixed-compare").removeClass("active");
                    $(".cards__filters").removeClass("active");
                }
            });
        },

        findValueInObjectArray(arr, searchKeys) {
            return arr.filter((obj) =>
                Object.keys(obj).some((key) => {
                    if (typeof obj[key] === "string") {
                        let found = false;
                        searchKeys.forEach((skey) => {
                            if (obj[key].includes(skey)) {
                                found = true;
                            }
                        });
                        if (found) return true;
                    }
                })
            );
        },
    },

    filters: {
        formatMobiles: function (value) {
            if (!value) return value;
            return value.replace(/\.0+$/, "");
        },
    },

    computed: {
        paralipseis() {
            let paralipseis = 0;
            if (this.member) {
                paralipseis += this.findValueInObjectArray(
                    this.member.fiscal[0].mobile_properties,
                    [
                        "Δεν συμπληρώθηκε",
                        "Δεν έχει συμπληρωθεί",
                        "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
                    ]
                ).length;
                paralipseis += this.findValueInObjectArray(
                    this.member.fiscal[0].properties,
                    [
                        "Δεν συμπληρώθηκε",
                        "Δεν έχει συμπληρωθεί",
                        "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
                    ]
                ).length;
                paralipseis += this.findValueInObjectArray(
                    this.member.fiscal[0].revenues,
                    [
                        "Δεν συμπληρώθηκε",
                        "Δεν έχει συμπληρωθεί",
                        "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
                    ]
                ).length;
                paralipseis += this.findValueInObjectArray(
                    this.member.fiscal[0].pmproducts,
                    [
                        "Δεν συμπληρώθηκε",
                        "Δεν έχει συμπληρωθεί",
                        "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
                    ]
                ).length;
                paralipseis += this.findValueInObjectArray(
                    this.member.fiscal[0].deposits,
                    [
                        "Δεν συμπληρώθηκε",
                        "Δεν έχει συμπληρωθεί",
                        "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
                    ]
                ).length;
                paralipseis += this.findValueInObjectArray(
                    this.member.fiscal[0].loans,
                    [
                        "Δεν συμπληρώθηκε",
                        "Δεν έχει συμπληρωθεί",
                        "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
                    ]
                ).length;
                paralipseis += this.findValueInObjectArray(
                    this.member.fiscal[0].companies,
                    [
                        "Δεν συμπληρώθηκε",
                        "Δεν έχει συμπληρωθεί",
                        "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
                    ]
                ).length;
                paralipseis += this.findValueInObjectArray(
                    this.member.fiscal[0].stocks,
                    [
                        "Δεν συμπληρώθηκε",
                        "Δεν έχει συμπληρωθεί",
                        "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
                    ]
                ).length;
            }
            return paralipseis;
        },

        role() {
            if (this.member.fiscal[0].goverment_position) {
                return this.member.fiscal[0].goverment_position.name;
            }
            if (this.member.fiscal[0].eu) {
                return "ΕΥΡΩΒΟΥΛΕΥΤΗΣ";
            }
            return "ΒΟΥΛΕΥΤΗΣ";
        },

        hasPartner() {
            return (
                this.member.fiscal[0].deposits.some((x) => x.partner) ||
                this.member.fiscal[0].revenues.some((x) => x.partner) ||
                this.member.fiscal[0].properties.some((x) => x.partner) ||
                this.member.fiscal[0].stocks.some((x) => x.partner) ||
                this.member.fiscal[0].loans.some((x) => x.partner) ||
                this.member.fiscal[0].companies.some((x) => x.partner) ||
                this.member.fiscal[0].mobile_properties.some((x) => x.partner)
            );
        },

        hasTotalsPartner() {
            return this.fiscal_totals.some((x) => x.with_partner);
        },
    },

    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                document.title = this.pageTitle;
            },
        },
    },
};
</script>
